export enum OfferAccessFlow {
  PrivateLockedDeal = 'privateLockedDeal',
  AppLocked = 'appLocked',
  SMSConfirmation = 'smsConfirmation'
}
